import { z } from "zod";
import { localDateSchema, rateSchema, uuidSchema } from "../common/primitives.js";
// ── Vergi oranları (platform düzeyi; geçerlilik tarihli — AGENTS.md §3.12) ────
export const taxRateCodeSchema = z
    .string()
    .trim()
    .toUpperCase()
    .regex(/^[A-Z][A-Z0-9_]{1,39}$/, "Kod büyük harf, rakam ve _ içerebilir (ör. VAT_STANDARD)");
export const taxRateSchema = z.object({
    id: uuidSchema,
    code: z.string(),
    taxType: z.enum(["VAT", "OTHER"]),
    rate: rateSchema.describe('Yüzde: "20" = %20'),
    validFrom: localDateSchema,
    validTo: localDateSchema.nullable().describe("Dâhil; null = açık uçlu"),
    description: z.string().nullable(),
    needsVerification: z.boolean().describe("Seed değeri; mevzuat/mali müşavir teyidi bekliyor"),
});
export const taxRateListSchema = z.object({ items: z.array(taxRateSchema) });
export const listTaxRatesQuerySchema = z.object({
    asOf: localDateSchema.optional().describe("Verilirse yalnızca bu tarihte geçerli oranlar döner"),
});
export const createTaxRateSchema = z
    .object({
    code: taxRateCodeSchema,
    taxType: z.enum(["VAT", "OTHER"]).default("VAT"),
    rate: rateSchema.refine((value) => Number(value) >= 0 && Number(value) <= 100, "Oran 0–100 arasında olmalıdır"),
    validFrom: localDateSchema,
    validTo: localDateSchema.nullable().default(null),
    description: z.string().trim().max(300).nullable().default(null),
    needsVerification: z.boolean().default(false),
    closePrevious: z
        .boolean()
        .default(true)
        .describe("Aynı kodun açık uçlu dönemi varsa, yeni dönemin başlangıcından bir gün önce kapatılır"),
})
    .refine((value) => value.validTo === null || value.validTo >= value.validFrom, {
    path: ["validTo"],
    message: "Bitiş tarihi başlangıçtan önce olamaz",
});
export const updateTaxRateSchema = z.object({
    validTo: localDateSchema.nullable().optional(),
    description: z.string().trim().max(300).nullable().optional(),
    needsVerification: z.boolean().optional(),
});
// ── KDV istisna kodları ──────────────────────────────────────────────────────
export const taxExemptionCodeSchema = z.object({
    id: uuidSchema,
    code: z.string(),
    name: z.string(),
    exemptionType: z.enum(["FULL", "PARTIAL", "OTHER"]),
    legalBasis: z.string().nullable(),
    isActive: z.boolean(),
    needsVerification: z.boolean(),
});
export const taxExemptionCodeListSchema = z.object({ items: z.array(taxExemptionCodeSchema) });
export const upsertTaxExemptionCodeSchema = z.object({
    code: z.string().trim().min(1).max(20),
    name: z.string().trim().min(1).max(300),
    exemptionType: z.enum(["FULL", "PARTIAL", "OTHER"]).default("FULL"),
    legalBasis: z.string().trim().max(300).nullable().default(null),
    isActive: z.boolean().default(true),
    needsVerification: z.boolean().default(false),
});
// ── Tevkifat kodları ─────────────────────────────────────────────────────────
export const withholdingCodeSchema = z.object({
    id: uuidSchema,
    code: z.string(),
    name: z.string(),
    numerator: z.number().int(),
    denominator: z.number().int(),
    isActive: z.boolean(),
    needsVerification: z.boolean(),
});
export const withholdingCodeListSchema = z.object({ items: z.array(withholdingCodeSchema) });
export const upsertWithholdingCodeSchema = z
    .object({
    code: z.string().trim().min(1).max(20),
    name: z.string().trim().min(1).max(300),
    numerator: z.number().int().positive(),
    denominator: z.number().int().positive(),
    isActive: z.boolean().default(true),
    needsVerification: z.boolean().default(false),
})
    .refine((value) => value.numerator <= value.denominator, {
    path: ["numerator"],
    message: "Pay paydadan büyük olamaz",
});
//# sourceMappingURL=tax.js.map